import Vue from 'vue'

import wx from "jweixin-1.6.0";

export const config = async (_this) => {
    let jsApiList = [
        "checkJsApi",
        "onMenuShareTimeline",
        "onMenuShareAppMessage",
        "updateAppMessageShareData",
        "updateTimelineShareData",
        "hideMenuItems",
        'startRecord', 
        'stopRecord', 
        'playVoice', 
        'pauseVoice', 
        'uploadVoice', 
        'downloadVoice'
    ];
    // 签名 URL — 必须使用页面首次加载时的完整 URL（iOS WKWebView realAuthUrl）
    var signUrl = window.__WX_INITIAL_URL?window.__WX_INITIAL_URL.replace('##','#') : window.location.href;
    console.log('signUrl', signUrl)
    // 分享链接 — 固定到首页，不分享二级页面出去
    var shareUrl = 'https://artsbird2026.dalawl.com/#/';
    let response = await _this.$api.getShareConfig(signUrl);
    if (response && response.success) {
        const { appId, nonceStr, signature, timestamp } = response.data;
        //通过微信config接口注入配置
        wx.config({
            debug: false, //默认为false 为true的时候是调试模式，会打印出日志
            appId: appId,
            timestamp: timestamp,
            nonceStr: nonceStr,
            signature: signature,
            jsApiList: jsApiList,
        });
        // config
        wx.ready(function () {
            let shareData = {
                title: `艺术，点亮城市的第25小时`, // 这是分享展示卡片的标题
                desc: ``, // 这是分享展示的摘要
                link: shareUrl, // 这里是分享的网址
                imgUrl:
                    "https://artsbird2026.dalawl.com/sharebg.png", // 这里是需要展示的图标
                img_url: "https://artsbird2026.dalawl.com/sharebg.png", // 这里是需要展示的图标
                success: function (rr) {
                    console.log("成功" + JSON.stringify(rr));
                },
                cancel: function (tt) {
                    console.log("失败" + JSON.stringify(tt));
                },
            };
            wx.checkJsApi({
                jsApiList: jsApiList,
                success: function (res) {
                    try {
                        // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容
                        if (res.checkResult.updateAppMessageShareData) {
                            wx.updateAppMessageShareData(shareData);
                        }
                    } catch (ex) {
                        console.log("updateAppMessageShareDataErr", ex);
                    }
                    try {
                        // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
                        if (res.checkResult.updateTimelineShareData) {
                            wx.updateTimelineShareData(shareData);
                        }
                    } catch (ex) {
                        console.log("updateTimelineShareDataErr", ex);
                    }
                    try {
                        // 获取“分享给朋友”按钮点击状态及自定义分享内容接口（即将废弃）
                        if (res.checkResult.onMenuShareAppMessage) {
                            wx.onMenuShareAppMessage(shareData);
                        }
                    } catch (ex) {
                        console.log("onMenuShareAppMessageErr", ex);
                    }
                    try {
                        // 获取“分享到朋友圈”按钮点击状态及自定义分享内容接口
                        if (res.checkResult.onMenuShareTimeline) {
                            wx.onMenuShareTimeline(shareData);
                        }
                    } catch (ex) {
                        console.log("onMenuShareTimelineErr", ex);
                    }
                },
            });
        });
        // 隐藏分享按钮
        // wx.hideMenuItems({
        //     menuList: [
        //         "menuItem:share:appMessage",
        //         "menuItem:share:timeline",
        //         "menuItem:share:qq",
        //         "menuItem:share:weiboApp",
        //         "menuItem:share:facebook",
        //         "menuItem:share:QZone",
        //     ],
        //     success: function (res) {
        //         console.log("已隐藏功能按钮");
        //     },
        //     fail: function (res) {
        //         console.log("隐藏功能按钮error" + JSON.stringify(res));
        //     },
        // });
        wx.error(function (res) {
            console.log("error", res);
        });
        wx.error(function (res) {
            console.log("error", res);
        });
    } else {
        _this.$toast("获取分享参数失败");
    }
    _this.$toast.clear();
}


// WEBPACK FOOTER //
// ./src/utils/wxShare.js